import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'normalize.css/normalize.css';
import './assets/css/reset.css';
import '@/assets/fonts/font.css'  // 字体样式
import './router/router-config'; // 路由守卫，做动态路由的地方
import { setDomFontSize } from '@/utils/rem.js'; // 设置跟字体
import element from "@/element";
import 'element-ui/lib/theme-chalk/index.css'

// Vue.use(Icon)
element.install(Vue)
Vue.config.productionTip = false;

setDomFontSize()

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
